import { Desc, Head3 } from 'Components/Typography/Text.styles'
import { EventHubExperience } from '../../../../Api'
import { ExperienceModalCon } from '../styles'
import { Lk } from 'Components/Links/Lk'
import { logEvent } from 'Utils'
import { ANALYTICS_TAGS } from 'Constant'

type ExperienceModalParams = {
  experience: EventHubExperience | null
}

export const ExperienceModal: React.FC<ExperienceModalParams> = ({ experience }) => {
  if (!experience) return null

  const onMoreCLick = () => {
    logEvent(ANALYTICS_TAGS.gameday_hub_experience_more_click, {
      title: experience.title,
      location: experience.location,
      link_text: experience.slideUpButtonText ?? 'Learn More',
      link: experience.slideUpButtonLink,
    })
  }

  return (
    <ExperienceModalCon>
      <Head3>{experience.title}</Head3>
      <Desc className="experience-modal-description">{experience.description}</Desc>
      {experience.location && (
        <Desc className="experience-modal-description">
          Location: {experience.location}
        </Desc>
      )}
      {experience.slideUpButtonLink && (
        <Lk
          link={experience.slideUpButtonLink ?? ''}
          alt={experience.slideUpButtonText ?? 'experience link'}
          onBeforeNavigate={onMoreCLick}
        >
          <div className="experience-modal-footer">
            <Head3>{experience.slideUpButtonText ?? 'Learn More'}</Head3>
          </div>
        </Lk>
      )}
    </ExperienceModalCon>
  )
}
